import React, { Component } from 'react';
import    Highcharts from 'highcharts';
//import { return } from 'node-regexp';
import HighchartsReact from 'highcharts-react-official';


class Chart extends Component{
    state = {
        chart: {},
    }
    componentDidMount= () => {
      console.log("[INFO], Generics HighChart, componentDidMount");
    }

    componentDidUpdate= () => {
      console.log("[INFO], Generics HighChart, componentDidUpdate ");
      console.log(this.props.options);
      console.log("[INFO], Generics HighChart, componentDidUpdate, [END]");
    }
    //Destroy chart before unmount.
    componentWillUnmount= () => {
   
    }
    //Create the div which the chart will be rendered to.
    render= () => {
        console.log("[INFO],Generics HighChart,",this.props.options);
        console.log("[DEBUG],Generics HighChart,",Highcharts);

        return(
            <HighchartsReact
              highcharts={Highcharts}
              options={this.props.options}
            />
       
        )
        //return React.createElement('div', { id: this.props.container });
    }
}

export default Chart;

//module.exports = Card
